import { isReadOnlySelector } from 'modules/MedComms/selectors';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ArtboardLayoutActions from 'components/ArtboardLayoutActions';
import {
  ArtboardLayoutActionsActions,
  ArtboardLayoutActionsOwnProps,
  ArtboardLayoutActionsSelectors,
} from 'components/ArtboardLayoutActions/models';
import { addActiveLayoutId, removeActiveLayoutId, setMoveableLayoutId } from 'containers/App/actions';
import { activeLayoutIds, areActionsDisabled, isResizingLayout } from 'containers/App/selectors';
import { documents } from 'containers/Documents/selectors';
import { setFrozenEntityIdAction } from 'containers/FrozenAction/actions';
import { getFrozenEntityId } from 'containers/FrozenAction/selectors';
import { copyLayout, deleteLayoutRequest, setLayoutAndInstances } from 'containers/Layouts/actions';
import { showModal } from 'containers/ModalManager/actions';
import { unlinkReusableLayout } from 'containers/ModalWindows/SaveReusableLayout/actions';
import { projectType } from 'containers/Project/selectors';

const mapStateToProps = createStructuredSelector({
  activeLayoutIds,
  areActionsDisabled,
  documents,
  isResizingLayout,
  projectType,
  isReadOnly: isReadOnlySelector,
  frozenEntityId: getFrozenEntityId,
});

const mapDispatchToProps = {
  addActiveLayoutId,
  copyLayout,
  removeActiveLayoutId,
  deleteLayout: deleteLayoutRequest,
  unlinkReusableLayout,
  // TODO: get rid of it
  setMoveableLayout: setMoveableLayoutId,
  showModal,
  setLayout: setLayoutAndInstances,
  setFrozenEntityIdAction,
};

export default connect<ArtboardLayoutActionsSelectors, ArtboardLayoutActionsActions, ArtboardLayoutActionsOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(ArtboardLayoutActions);
